import { checkUserExist } from '@/components/marketing-landing-page/action'
import { getCampaignParams } from '@/lib/events/helper'
import parsePhoneNumberFromString from 'libphonenumber-js'
import { APP_METHODS } from '../enums'
import { checkNewUser, invokeAppMethod } from '../utils'

export const onOneTapOtpless = async ({
  otplessToken,
  mobileNumber,
  deviceManufacturer,
}: {
  otplessToken: string
  mobileNumber: string
  deviceManufacturer: string
}) => {
  const channel = 'OAUTH'
  const phoneNumberObj = parsePhoneNumberFromString('+' + mobileNumber)
  const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getCampaignParams()

  if (channel === 'OAUTH') {
    const nationalNumber = phoneNumberObj?.nationalNumber
    const res: any = await checkUserExist(nationalNumber as string)
    const userExists = res && res?.success
    if (userExists) {
      localStorage.setItem('shouldRegister', 'false')
    } else {
      localStorage.setItem('shouldRegister', 'true')
    }
  }
  localStorage.setItem('OTP_VERIFICATION_CHANNEL', channel)
  window.PWWebSDK.apiClient
    .post<any>(`${process.env.NEXT_PUBLIC_API_BASE_URL_AUTH}/v3/oauth/public/otpless-verify-token`, {
      token: otplessToken,
      organizationId: window.PWWebSDK.config?.organizationId,
      firstName: '',
      utm_source,
      utm_medium,
      utm_campaign,
      device: deviceManufacturer,
      pageType: '',
      mlpName: '',
      mlpType: '',
    })
    .then((tokenResponse: any) => {
      window.PWWebSDK.setTokenContext = {
        token: tokenResponse.data.access_token,
        refresh_token: tokenResponse.data.refresh_token,
        randomId: window.PWWebSDK.randomId,
        expires_in: tokenResponse.data.expires_in,
      }
      window.PWWebSDK.setUser = tokenResponse.data.user

      invokeAppMethod(
        APP_METHODS.SAVE_USER,
        JSON.stringify({
          token: tokenResponse.data.access_token,
          refresh_token: tokenResponse.data.refresh_token,
          is_new_user: checkNewUser(tokenResponse.data.user),
          batch_id: '',
          target_screen: '',
        }),
      )

      const customEvent = new CustomEvent('otpless:auth-success', {
        detail: {
          user: tokenResponse.data.user,
        },
      })
      document.dispatchEvent(customEvent)
    })
}
